import React from "react";
import './common.less'
import Play from "@assets/images/play.png";
import Pause from "@assets/images/pause.png";
import { connect } from "react-redux";
import {setChristmasInit} from "tools/store";


//全局状态
const mapStateToProps = (state: any) => {
  return {
    christmasInit: state.defaultState.christmasInit,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  setChristmasInit: (v: any) => {
    dispatch(setChristmasInit(v));
  },
});
@(connect(mapStateToProps, mapDispatchToProps) as any)
class Music extends React.Component<any, any> {
  // constructor(props: any) {
  //   super(props);
  // }
  componentDidMount(){
    if(this.props.christmasyInit){
      let music:any=this.refs.music;
      music.play();
    }
    if( window.innerWidth>750){
      let CSS2:any=this.refs.CSS2;
      CSS2.style.left=(window.innerWidth-750)/2+664+'px'; 
    }
  }

  componentWillUnmount(){
    this.setState = () => false;
  }
  play=()=>{
    //播放音乐
    let music:any=this.refs.music;
    if(this.props.christmasInit){
      music.pause();
      this.props.setChristmasInit(false)
    }else{
      music.play();
      this.props.setChristmasInit(true)
    }
    
  };
  render() {
    return (
     <div className='component-music'>
       <audio src={require("../assets/images/music.mp3")} autoPlay={this.props.christmasInit?true:false} ref="music" loop></audio>
      <div className="musicPlay" ref={"CSS2"}><img className={this.props.christmasInit ? "goPlay" : ""} src={this.props.christmasInit ? Play : Pause}  onClick={this.play} alt=""/></div>
     </div>
    );
  }
}

export default Music;
